const general = {
    placeholder: 'Placeholder',
    skip: 'Skip',
    next: 'Next',
    retry: 'Try Again',
    done: 'Done',
    search: 'Search',
    search_placeholder: 'Search',
    clear_result: 'Clear Results',
    save: 'Save',
    save_changes: 'Save Changes',
    saved: 'Saved!',
    discard: 'Discard',
    loading: 'Loading...',
    redirecting: 'Redirecting...',
    add: 'Add',
    added: 'Added',
    cancel: 'Cancel',
    confirm: 'Confirm',
    check_out: 'Check Out',
    create: 'Create',
    set_up: 'Set Up',
    customize: 'Customize',
    enable: 'Enable',
    reminder: 'Reminder',
    delete: 'Delete',
    more_options: 'MORE OPTIONS',
    close: 'Close',
    copy: 'Copy',
    copying: 'Copying',
    copied: 'Copied',
    required: 'Required',
    add_another: '+ Add Another',
    deletion_confirmation: 'Are you sure you want to delete this {{title}}?',
    settings_nav: 'Settings',
    unsaved_changes_warning: 'You have made some changes. Are you sure you want to leave this page?',
    leave_page: 'Leave Page',
    stay_on_page: 'Stay on Page',
    type_to_search: 'Type to search',
    got_it: 'Got it',
    page_info: '{{min, number}}-{{max, number}} of {{total, number}}',
    learn_more: 'Learn more',
    tab_errors: '{{count, number}} errors',
};
export default general;
